// Text lockup of the Accruewise wordmark for light surfaces.
export default function Wordmark({ className = "" }) {
    return (
        <span
            className={`select-none font-sans text-xl font-bold lowercase tracking-tight text-ink ${className}`}
        >
            acc<span className="text-brand">₹</span>uewise
        </span>
    );
}
